enum ApiName {
    SPECIFICATION = 'specification',
    LIST = 'list'
}

export default ApiName;
